// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-08426de7].mce-last {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n[data-v-08426de7] .mce-toolbar {\n  width: 500px;\n  overflow-x: auto;\n}\n[data-v-08426de7] ::-webkit-scrollbar {\n  height: 8px;\n}", ""]);
// Exports
module.exports = exports;
